export { default } from './ModalRewardInProgress';
